import Skeleton from "react-loading-skeleton";
import Loader from "react-js-loader";
import styles from "./SkeletonLoader.module.css";
const SkeletonLoader = ({ isDeviceMobile }: { isDeviceMobile: boolean }) => {
  return (
    <div className="vas-w-100">
      <div
        className="vas-d-flex vas-gap-3 vas-justify-content-center vas-align-items-start vas-w-100"
        // dir={language === "ar" ? "rtl" : "ltr"}
        style={
          {
            // width: source === "mobile" ? "90%" : "57%",
            // maxWidth: "1170px",
          }
        }
      >
        <div
          className={`vas-p-3 vas-w-100 vas-d-flex vas-flex-column vas-gap-3  ${
            isDeviceMobile ? "" : "vas-border-radius vas-shadow vas-border"
          } vas-bg-white`}
        >
          <div className="vas-w-100 vas-fs-7 vas-m-0">
            <Skeleton
              className={`vas-my-2 vas-w-50 ${styles.header}`}
              height={30}
            />
            <Skeleton
              className={`vas-my-2 vas-w-50 ${styles.infoHeader1}`}
              height={35}
            />
            <Skeleton
              className={`vas-my-2 vas-w-50 ${styles.infoHeader2}`}
              height={35}
            />
            <Skeleton
              className={`vas-my-2 vas-d-sm-none vas-w-50 ${styles.infoHeader2}`}
              height={35}
            />
            <Skeleton
              className={`vas-my-2 vas-w-25 ${styles.infoHeaderHint}`}
              height={20}
            />
            <Skeleton
              className={`vas-mb-5 vas-w-75 ${styles.smallText}`}
              height={25}
            />
          </div>
          <div className="vas-my-5 vas-align-self-center">
            <Loader className="vas-my-5" bgColor={"#2CA95E"} size={100} />
          </div>
        </div>
        {!isDeviceMobile && (
          <div
            className={`vas-p-3 vas-d-flex vas-flex-column vas-gap-1 vas-w-50 vas-shadow vas-border vas-bg-white vas-border-radius`}
          >
            <Skeleton
              className={`vas-my-2 vas-w-75 ${styles.header}`}
              height={30}
            />

            <Skeleton
              className={`vas-my-2 vas-w-50 ${styles.header}`}
              height={22}
            />

            <Skeleton
              className={`vas-my-2 vas-w-100 vas-border-radius ${styles.header}`}
              height={40}
            />

            <Skeleton
              className={`vas-my-2 vas-w-100 vas-border-radius ${styles.header}`}
              height={40}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SkeletonLoader;
